import React from 'react';
import styled from 'styled-components';
import useIsMobileView from "../hooks/useIsMobileView";
import { Main, MainContent, Section, Footer } from '@prosolve/common-components-ui'
import GoHubTopNav from '../sharedComponents/GoHubTopNav';
import ImplementationCalendarPage from './ImplementationCalendarPage';
import './ImplementationCalendar.css'

const SectionDivider = () => <div style={{ height: '10px' }}>&nbsp;</div>

// Rendered inside the dark hub top bar (GoHubTopNav appLogo slot)
const HubBarTitle = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
`

export default ({ isPrivate }) => {
  const isMobileView = useIsMobileView();
  
  return (
    <>
    { isPrivate && <GoHubTopNav appLogo={<HubBarTitle>{'Implementation Calendar'}</HubBarTitle>} />}
    <Main 
      $isMobileView={isMobileView} 
      $backgroundColor={'#ffffff'}
      $hasNavHeader={isPrivate}
      style={{ padding: '0', marginTop: isPrivate ? '39px' : undefined }}
    >
      <MainContent $isMobileView={isMobileView} style={{ width: '100%', maxWidth: '100%' }}>
        <div style={{ padding: '0px' }}>
          <Section style={{ padding: '0px' }}>
            <ImplementationCalendarPage />
          </Section>
        </div>
        <SectionDivider />
        <Footer />
      </MainContent>
    </Main>
    </>
  )
}
